import {SODeletePlanWorkAssociation} from '../../core/plan-work-association/so-delete-plan-work-association';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeletePlanWorkAssociation extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeletePlanWorkAssociation;
}